import React, { useEffect, useState } from "react";
import PageBreadcrumb from "../../components/common/CustomBreadCrumb";
import ComponentCard from "../../components/common/ComponentCard";
import PageMeta from "../../components/common/PageMeta";
import Input from "../../components/form/input/InputField";
import { Search } from "lucide-react";
import NotificationService from "@/services/notification.service";
import { useTranslation } from "react-i18next";
import NotificationHistoryTable from "@/components/tables/NotificationHistoryTable";
import { useParams } from "react-router";
import NotificationHistoryDetailsTable from "@/components/tables/NotificationHistoryDetailsTable";

export default function ViewNotificationHistories() {
    const { id } = useParams();
    const { t } = useTranslation();
    const [params, setParams] = useState({
        page: 1,
        limit: 10,
        search: "",
    });
    const [totalPages, setTotalPages] = useState(0);
    const [error, setError] = useState("");
    const [notificationHistories, setNotificationHistories] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const fetchNotificationHistories = async (page: number) => {
        setIsLoading(true);
        setError("");
        try {
            const response = await NotificationService.viewNotificationHistories(id || "", {
                ...params,
                page,
            });
            const addDatas = response.data.notifications || [];
            setTotalPages(Math.ceil((response.data.count || 0) / params.limit));
            setNotificationHistories(addDatas);
            setIsLoading(false);
        } catch (err) {
            setError(t("Failed to fetch notification histories. Please try again later."));
            setIsLoading(false);
        } finally {
            setTimeout(() => {
                setIsLoading(false);
            }, 1000);
        }
    };

    useEffect(() => {
        fetchNotificationHistories(params.page);
    }, []);
    const handlePageChange = (page: number) => {
        setParams({
            ...params,
            page,
        });
        fetchNotificationHistories(page);
    };

    return (
        <>
            <PageMeta
                title={t("VIYUME - VIYUME Dashboard")}
                description=""
            />
            <div className="space-y-6">
                <ComponentCard title="">
                    <div className="mb-4 relative">
                        <Input
                            type="text"
                            placeholder={t("Search notifications") + "..."}
                            value={params.search}
                            onChange={(e) => setParams({
                                ...params,
                                page: 1,
                                limit: 10,
                                search: e.target.value
                            })}
                            onEnter={(value) => {
                                fetchNotificationHistories(params.page);
                            }}
                            className="pl-10"
                        />
                        <Search className="w-5 h-5 absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                    </div>
                    {isLoading ? (
                        <div className="animate-pulse">
                            <div className="space-y-4">
                                {[...Array(5)].map((_, index) => (
                                    <div key={index} className="flex items-center space-x-4 py-3">
                                        <div className="h-4 bg-gray-200 rounded w-1/4"></div>
                                        <div className="h-4 bg-gray-200 rounded w-1/4"></div>
                                        <div className="h-4 bg-gray-200 rounded w-1/6"></div>
                                        <div className="h-4 bg-gray-200 rounded w-1/6"></div>
                                        <div className="h-4 bg-gray-200 rounded w-1/6"></div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ) : error ? (
                        <div className="text-red-500 text-center p-4">{error}</div>
                    ) : (
                        <NotificationHistoryDetailsTable
                            notificationHistories={notificationHistories}
                            currentPage={params.page}
                            totalPages={totalPages}
                            onPageChange={handlePageChange}
                        />
                    )}
                </ComponentCard>
            </div>
        </>
    );
}
